import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloud,
  faGifts,
  faHeart,
  faMusic,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import MainLayout from "../layouts/MainLayout";

const NotFound = () => {
  return (
    // <MainLayout>
    <>
      <div className="my-2 mx-auto max-w-[700px] py-4 flex flex-col justify-center items-center">
        <div className="mt-2 mx-4 flex justify-center items-center">
          <img
            className="w-full max-w-5xl h-auto object-contain"
            src="/Image404.png"
            alt="404"
          />
        </div>
        <div className="spinner mt-2">
          <FontAwesomeIcon icon={faStar} spin />
        </div>
        <div className="mt-3 mx-4 flex justify-center text-center">
          <h2 className="max-w-4xl text-sm leading-relaxed text-cyan-200 sm:text-base md:text-lg lg:text-xl">
            <FontAwesomeIcon
              icon={faHeart}
              className="mr-1 text-base text-red-500 sm:text-lg md:text-xl"
            />
            <span className="font-semibold text-white">Shhh... 🤫</span>{" "}
            <span className="text-purple-300">
              This page is taking a peaceful little nap. 💤
            </span>{" "}
            <span className="text-cyan-200">
              We're quietly working behind the scenes to make it better.
            </span>{" "}
            <span className="text-yellow-300">
              Soon, it will wake up refreshed and ready to welcome you. ✨
            </span>{" "}
            <span className="text-gray-300">Thanks for your patience!</span>
            <FontAwesomeIcon
              icon={faStar}
              className="ml-2 text-base text-yellow-400 sm:text-lg md:text-xl"
            />
            <FontAwesomeIcon
              icon={faHeart}
              className="ml-1 text-base text-red-500 sm:text-lg md:text-xl"
            />
            <FontAwesomeIcon
              icon={faCloud}
              className="ml-1 text-base text-gray-400 sm:text-lg md:text-xl"
            />
            <FontAwesomeIcon
              icon={faMusic}
              className="ml-1 text-base text-yellow-400 sm:text-lg md:text-xl"
            />
          </h2>
        </div>
      </div>
    </>
    // </MainLayout>
  );
};

export default NotFound;
